module.exports = __webpack_public_path__ + "static/pasaporte-fa3312e5d5a0d122d126ed8089fd55ed.svg";